import { useMutation, useQueryClient } from '@tanstack/react-query';
import { eventMonitorApi } from '../api/eventMonitorApi';

/**
 * DELETE /api/eraf/event-monitor/buffer
 * buffer 클리어 뮤테이션
 */
export function useClearBuffer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => eventMonitorApi.clearBuffer(),
    onSuccess: () => {
      // 목록 쿼리 무효화 — 빈 상태로 갱신
      void queryClient.invalidateQueries({ queryKey: ['event-monitor', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['event-monitor', 'filters'] });
    },
  });
}
